// import { Component, OnDestroy, Renderer2, ViewChild } from '@angular/core';
// import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { TabCloseEvent } from './api/tabcloseevent';
import { MenuService } from './app.menu.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { AppTopBarComponent } from './app.topbar.component';
import { LayoutService } from './service/app.layout.service';
import { Component, OnDestroy, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { WebStorage } from '../demo/components/auth/storage/web.storage';
import { LookupService } from '../demo/service/lookup.service';
import { HttpResponse } from '@angular/common/http';
import { ScheduleDTO } from '../demo/model/ScheduleDTO';
import { SchoolDTO } from '../demo/model/SchoolDTO';
import { MomentDatePipe } from '../demo/sharing/pipes/moment-date.pipe';
import { Common } from '../demo/utils/common';

@Component({
    selector: 'app-layout',
    templateUrl: './app.layout.component.html',
})
export class AppLayoutComponent implements OnInit, OnDestroy {

    overlayMenuOpenSubscription: Subscription;

    tabOpenSubscription: Subscription;

    tabCloseSubscription: Subscription;

    menuOutsideClickListener: any;

    menuScrollListener: any;

    @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

    @ViewChild(AppTopBarComponent) appTopbar!: AppTopBarComponent;
    userdata!: any;
    public userloaded = false;
    constructor(     private webStorage: WebStorage,  private lookupService: LookupService,private menuService: MenuService, public layoutService: LayoutService, public renderer: Renderer2, 
        public router: Router) {


            const logValue = localStorage.getItem('logQueryParam');        
            const refTable = logValue === 'Staff' || logValue === null ? 'Staff' : 'Guardian';
            this.lookupService.queryAccount({ 'refTable': refTable }).subscribe((account: any) => {
                this.lookupService.getSchoolById(Number(account.body.schoolId)).subscribe((res : HttpResponse<SchoolDTO>)=>{
                    let userObj : any = { };
                    userObj = account.body;
                    userObj.schoolObj = res.body;
                    if (userObj.schoolObj) {
                        this.webStorage.login(userObj);
                        Common.setTimeZone(userObj.schoolObj?.timeZone);
                        this.userloaded = true;
                    }
                });
            });  
            
            
                
            

        this.overlayMenuOpenSubscription = this.layoutService.overlayOpen$.subscribe(() => {
            if (!this.menuOutsideClickListener) {
                this.menuOutsideClickListener = this.renderer.listen('document', 'click', event => {
                    const isOutsideClicked = !(this.appSidebar.el.nativeElement.isSameNode(event.target) || this.appSidebar.el.nativeElement.contains(event.target)
                    || this.appTopbar.menuButton.nativeElement.isSameNode(event.target) || this.appTopbar.menuButton.nativeElement.contains(event.target));
                    if (isOutsideClicked) {
                        this.hideMenu();
                    }
                });
            }

            if ((this.layoutService.isSlim() || this.layoutService.isSlimPlus()) && !this.menuScrollListener) {
                this.menuScrollListener = this.renderer.listen(this.appSidebar.menuContainer.nativeElement, 'scroll', event => {
                    if (this.layoutService.isDesktop()) {
                        this.hideMenu();
                    }
                });
            }

            if (this.layoutService.state.staticMenuMobileActive) {
                this.blockBodyScroll();
            }
        });

        this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.hideMenu();
            });

        this.tabOpenSubscription = this.layoutService.tabOpen$.subscribe(tab => {
            this.router.navigate(tab.routerLink);
            this.layoutService.openTab(tab);
        });

        this.tabCloseSubscription = this.layoutService.tabClose$.subscribe((event: TabCloseEvent) => {
            if (this.router.isActive(event.tab.routerLink[0], { paths: 'subset', queryParams: 'subset', fragment: 'ignored', matrixParams: 'ignored'})) {
                const tabs = this.layoutService.tabs;

                if (tabs.length > 1) {
                    if (event.index === (tabs.length - 1))
                        this.router.navigate(tabs[tabs.length - 2].routerLink);
                    else
                        this.router.navigate(tabs[event.index + 1].routerLink);
                }
                else {
                    this.router.navigate(['/']);
                }
            }

            this.layoutService.closeTab(event.index);
        });
    }

    ngOnInit() {
        // this.loadProduktlyScript();
        // this.loadZohoSalesIQScript();
    }

    // private loadProduktlyScript() {
    //     (window as any).Produktly = (window as any).Produktly || new Proxy(() => {}, {
    //         get: function(_, n) {
    //             return (...a: any[]) => {
    //                 (window as any).ProduktlyQ = ((window as any).ProduktlyQ || []).concat([[n, a]]);
    //             };
    //         },
    //         apply: function(_, __, a) {
    //             (window as any).ProduktlyQ = ((window as any).ProduktlyQ || []).concat([["apply", a]]);
    //         }
    //     });

    //     const script = this.renderer.createElement('script');
    //     script.async = true;
    //     script.src = 'https://public.produktly.com/js/main.js';
    //     script.id = 'produktlyScript';
    //     script.setAttribute('data-client-token', '4b39bde70156f13db3ddc426825697bc40bd1bf2f07516cb204b9c028ed002c3f3fa7dff16dae0f896a5a902db24ef3f2c4b503b95847a7062c8b733eb9eddf707f788bfe09b39bc2999127e3ce3b9c30d02e6acf6a35217be352e4c08fdd439e3f34609');
    //     this.renderer.appendChild(document.head, script);
    // }

    // private loadZohoSalesIQScript() {
    //     // Initialize Zoho SalesIQ
    //     (window as any).$zoho = (window as any).$zoho || {};
    //     (window as any).$zoho.salesiq = (window as any).$zoho.salesiq || { ready: function() {} };

    //     // Load the Zoho SalesIQ script
    //     const script = this.renderer.createElement('script');
    //     script.src = 'https://salesiq.zohopublic.com/widget?wc=siqcab407fca7d416b70e87700a8747a0c31889c6b56b14809dcb2b29b9933f0505';
    //     script.id = 'zsiqscript';
    //     script.defer = true;
    //     this.renderer.appendChild(document.head, script);
    // }


    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        }
        else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        }
        else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    hideMenu() {
        this.layoutService.state.overlayMenuActive = false;
        this.layoutService.state.staticMenuMobileActive = false;
        this.layoutService.state.menuHoverActive = false;
        this.menuService.reset();
        if(this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
            this.menuOutsideClickListener = null;
        }

        if (this.menuScrollListener) {
            this.menuScrollListener();
            this.menuScrollListener = null;
        }

        this.unblockBodyScroll();
    }

    get containerClass() {
        return {
            'layout-slim': this.layoutService.config.menuMode === 'slim',
            'layout-slim-plus': this.layoutService.config.menuMode === 'slim-plus',
            'layout-static': this.layoutService.config.menuMode === 'static',
            'layout-overlay': this.layoutService.config.menuMode === 'overlay',
            'layout-overlay-active': this.layoutService.state.overlayMenuActive,
            'layout-mobile-active': this.layoutService.state.staticMenuMobileActive,
            'layout-static-inactive': this.layoutService.state.staticMenuDesktopInactive && this.layoutService.config.menuMode === 'static',
            'p-input-filled': this.layoutService.config.inputStyle === 'filled',
            'p-ripple-disabled': !this.layoutService.config.ripple,
            'layout-light': this.layoutService.config.layoutTheme === 'colorScheme' && this.layoutService.config.colorScheme === 'light',
            'layout-dark': this.layoutService.config.layoutTheme === 'colorScheme' && this.layoutService.config.colorScheme === 'dark',
            'layout-primary': this.layoutService.config.colorScheme !== 'dark' && this.layoutService.config.layoutTheme === 'primaryColor'
        }
    }

    ngOnDestroy() {
        if (this.overlayMenuOpenSubscription) {
            this.overlayMenuOpenSubscription.unsubscribe();
        }

        if (this.menuOutsideClickListener) {
            this.menuOutsideClickListener();
        }

        if (this.tabOpenSubscription) {
            this.tabOpenSubscription.unsubscribe();
        }

        if (this.tabCloseSubscription) {
            this.tabCloseSubscription.unsubscribe();
        }
    }

}

